import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Button, Col, FormGroup, FormControl, Glyphicon, Row } from 'react-bootstrap';

import ReusableTable from '../tables/ReusableTable.jsx';
import ActionCellRenderer from '../tables/ActionCellRenderer.jsx';
import validation from '../../lib/validation';

import { addToGroup, updateInGroup, removeFromGroup } from '../../actions/form';

export class ReferenceForm extends Component {
  constructor(props) {
    super(props);

    /* istanbul ignore next */
    this.state = {
      inputs: {
        name: '',
        phone: '',
        email: '',
        comments: '',
      },
      edit: false,
      rules: {},
    };

    this.columnDefs = [
      { headerName: 'Name', field: 'name', minWidth: 200 },
      { headerName: 'Relationship', field: 'comments', minWidth: 200 },
      { headerName: 'Phone', field: 'phone', minWidth: 100 },
      { headerName: 'Email', field: 'email', minWidth: 120 },
      {
        headerName: 'Actions',
        field: 'actions',
        minWidth: 100,
        cellRendererFramework: ActionCellRenderer,
      },
    ];

    this.onNameChange = this.onNameChange.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.onEmailChange = this.onEmailChange.bind(this);
    this.onCommentsChange = this.onCommentsChange.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onAdd = this.onAdd.bind(this);
    this.resetFields = this.resetFields.bind(this);
    this.validateAll = this.validateAll.bind(this);
    this.getValidationStates = this.getValidationStates.bind(this);
    this.editHandler = this.editHandler.bind(this);
  }

  componentDidUpdate() {
    if (this.props.rules && !_.isEqual(this.props.rules, this.state.rules)) {
      this.setState({ rules: this.props.rules });
    }
  }
  onNameChange(e) {
    const updates = this.state;
    updates.inputs.name = e.target.value;
    this.setState(updates);
  }
  onEmailChange(e) {
    const updates = this.state;
    updates.inputs.email = e.target.value;
    this.setState(updates);
  }
  onPhoneChange(e) {
    const updates = this.state;
    updates.inputs.phone = e.target.value;
    this.setState(updates);
  }
  onCommentsChange(e) {
    const updates = this.state;
    updates.inputs.comments = e.target.value;
    this.setState(updates);
  }
  onCancel() {
    this.resetFields();
    if (this.state.edit) this.cancelEdit();
  }
  onAdd() {
    // Validate all fields
    if (this.validateAll()) {
      const recordToAdd = {
        name: this.state.inputs.name,
        phone: this.state.inputs.phone,
        email: this.state.inputs.email,
        comments: this.state.inputs.comments,
      };

      this.props.addToGroup('references', recordToAdd);

      this.resetFields();
      this.setState({ edit: false });
    }
  }
  getValidationStates() {
    // generates a map of validation state strings usable by bootstrap's FormGroup
    const fieldValues = this.state.inputs;

    let name = null;
    if (fieldValues.name !== '') {
      name = this.validateName() ? 'success' : 'error';
    }
    let phone = null;
    if (fieldValues.phone !== '') {
      phone = this.validatePhone() ? 'success' : 'error';
    }
    let email = null;
    if (fieldValues.email !== '') {
      email = this.validateEmail() ? 'success' : 'error';
    }
    let comments = null;
    if (fieldValues.comments !== '') {
      comments = 'success';
    }
    return { name, phone, email, comments };
  }
  cancelEdit() {
    this.props.addToGroup('references', this.state.edit);
    this.resetFields();
    this.setState({ edit: false });
  }
  editHandler(index) {
    const reference = this.props.references[index];
    if (!reference) {
      // Add alert modal here
      return;
    }

    // Save a copy of the reference we're editing and populate input fields
    const updates = this.state;
    updates.edit = reference; // store reference to retrieve in case of 'cancel'
    updates.inputs.name = reference.name;
    updates.inputs.phone = reference.phone;
    updates.inputs.email = reference.email;
    updates.inputs.comments = reference.comments;

    this.setState(updates);
    this.props.removeFromGroup('references', index);
  }
  resetFields() {
    const updates = _.cloneDeep(this.state);
    updates.inputs = {
      name: '',
      phone: '',
      email: '',
      comments: '',
    };
    this.setState(updates);
  }
  validateName() {
    const name = this.state.inputs.name;
    return validation.run(_.get(this.state, 'rules.name'), name);
  }
  validatePhone() {
    const phone = this.state.inputs.phone;
    return validation.run(_.get(this.state, 'rules.phone'), phone);
  }
  validateEmail() {
    const email = this.state.inputs.email;
    return validation.run(_.get(this.state, 'rules.email'), email);
  }
  validateAll() {
    let valid = true;
    const validations = [
      this.validateName(),
      this.validatePhone(),
      this.validateEmail(),
    ];
    _.each(validations, (_validation) => {
      valid = valid && _validation;
    });
    return valid;
  }

  render() {
    const validationStates = this.getValidationStates();
    let addButton;

    if (this.state.edit) {
      addButton = (
        <Button onClick={this.onAdd}>
          <Glyphicon glyph="pencil" /> Update Reference
        </Button>
      );
    } else {
      addButton = (
        <Button onClick={this.onAdd}>
          <Glyphicon glyph="plus" /> Add Reference
        </Button>
      );
    }

    return (
      <div className="container-fluid form-container">
        <Row>
          <Col lg={12} className="form-title-container">
            <h1>{this.props.currentUserLevel}</h1>
            <span className="form-title-span">{this.props.name}</span>
            <p className="subtext">(People who can speak about your driving ability, work ethic etc.)</p>
          </Col>
        </Row>
        <form id="reference-form" autoComplete="off">
          <Row>
            <Col sm={6}>
              <FormGroup controlId="reference-name-input" validationState={validationStates.name}>
                <FormControl
                  type="text"
                  value={this.state.inputs.name}
                  placeholder="Name"
                  onChange={this.onNameChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup controlId="reference-comments-input" validationState={validationStates.comments}>
                <FormControl
                  type="text"
                  value={this.state.inputs.comments}
                  placeholder="Relationship"
                  onChange={this.onCommentsChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <FormGroup controlId="reference-phone-input" validationState={validationStates.phone}>
                <FormControl
                  type="text"
                  value={this.state.inputs.phone}
                  placeholder="Phone #"
                  onChange={this.onPhoneChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
            <Col sm={6}>
              <FormGroup
                controlId="reference-email-input"
                validationState={validationStates.email}
              >
                <FormControl
                  type="text"
                  value={this.state.inputs.email}
                  placeholder="Email Address"
                  onChange={this.onEmailChange}
                />
                <FormControl.Feedback />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <div className="form-control-btn-container pull-right">
              <Button onClick={this.onCancel} style={{ marginRight: '5px' }}>
                <Glyphicon glyph="remove" /> Cancel
              </Button>
              {addButton}
            </div>
          </Row>
          <Row>
            <ReusableTable
              references={this.props.references}
              columnDefs={this.columnDefs}
              editHandler={this.editHandler}
            />
          </Row>
        </form>
      </div>
    );
  }
}

export const mapStateToProps = state => ({
  references: _.get(state, 'form.profile.fields.references', []),
});

export default connect(
  mapStateToProps,
  { addToGroup, updateInGroup, removeFromGroup },
)(ReferenceForm);
